import { Comment } from '@nemuru-eng/js-api-client';

export const getExistingChannelsInComments = (comments: Comment[]): string[] => {
  const existingChannels = new Set<string>();
  comments.forEach((obj) => {
    const channel = obj.channel;
    existingChannels.add(channel);
  });
  return [...existingChannels];
};
